/** @jsxImportSource @emotion/react */
import Grid from "@mui/material/Grid";
import PropTypes from "prop-types";
import { useState } from "react";
import { BID_ACTIONS, BID_STATUS, BID_TYPE } from "../../util/bid/bidConstants.js";
import BidAdminActionCheckDialog from "./BidAdminActionCheckDialog.jsx";
import { Box, Button } from "@mui/material";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min.js";
import { FEATURES, NON_CONTRACT } from "../../util/constants.js";
import { getUnionContractGivenWorkgroup } from "../../util/workgroupMapper.js";

const BidAdminAction = (props) => {
  const history = useHistory();
  const [isActionCheckDialogOpen, setIsActionCheckDialogOpen] = useState(false);
  const [actionSelected, setActionSelected] = useState("");

  const getStatusActions = (action) => {
    return (
      <Grid container>
        <Grid item xs={6} md={12}>
          <Button
            variant={action === BID_ACTIONS.AWARD || action === BID_ACTIONS.RESULTS ? "contained" : "outlined"}
            color="primary"
            onClick={() => handleActionClicked(action)}
            sx={{ width: "110px" }}
            disabled={
              props.bid.bidType === BID_TYPE.SHIFT &&
              props.bid.status === BID_STATUS.CLOSED &&
              action === BID_ACTIONS.AWARD &&
              !props.bid.s3AllEmpPermBidData &&
              getUnionContractGivenWorkgroup(props.bid.workgroup) !== NON_CONTRACT
            }
          >
            {action}
          </Button>
        </Grid>
      </Grid>
    );
  };

  const getActionsBasedOnStatus = (status) => {
    switch (status) {
      case BID_STATUS.PENDING:
        return getStatusActions(BID_ACTIONS.DELETE);
      case BID_STATUS.OPEN:
        return getStatusActions(BID_ACTIONS.WITHDRAW);
      case BID_STATUS.AWARDED:
        return (
          <>
            <Box sx={{ marginTop: "2px" }}>{getStatusActions(BID_ACTIONS.RESULTS)}</Box>
            <Box mt={1} mb={1}>
              {getStatusActions(BID_ACTIONS.WITHDRAW)}
            </Box>
          </>
        );
      case BID_STATUS.CLOSED:
        return (
          <>
            <Box sx={{ marginTop: "2px" }}>{getStatusActions(BID_ACTIONS.AWARD)}</Box>
            <Box mt={1} mb={1}>
              {getStatusActions(BID_ACTIONS.WITHDRAW)}
            </Box>
          </>
        );
      case BID_STATUS.WITHDRAWN:
      case BID_STATUS.DELETED:
        return <div></div>;
      default:
        return "uh oh";
    }
  };

  const handleActionClicked = (actionName) => {
    switch (actionName) {
      case BID_ACTIONS.AWARD:
      case BID_ACTIONS.RESULTS:
        const bidChildItems = props.featureConfig.childItems;
        const manageBidFeature = bidChildItems.find((item) => item.key === FEATURES.MANAGE_BID);
        history.push({
          pathname: manageBidFeature.path.replace(":referenceNumber", props.bid.referenceNumber),
          state: { isAwardClicked: true },
        });
        return;
      case BID_ACTIONS.DELETE:
      case BID_ACTIONS.WITHDRAW:
      default:
        setActionSelected(actionName);
        handleClickActionDialogOpen();
        return;
    }
  };

  const handleClickActionDialogOpen = () => {
    setIsActionCheckDialogOpen(true);
  };

  const handleClickActionDialogClose = (event, reason) => {
    if (reason && reason === "backdropClick") return;
    setIsActionCheckDialogOpen(false);
  };

  return (
    <Grid
      sx={{
        lineHeight: "normal",
        textAlign: "left",
      }}
      data-testid="bid-admin-action"
    >
      {getActionsBasedOnStatus(props.bid.status)}
      {isActionCheckDialogOpen && (
        <BidAdminActionCheckDialog
          bid={props.bid}
          isDialogOpen={isActionCheckDialogOpen}
          actionSelected={actionSelected}
          onClickDialogClose={handleClickActionDialogClose}
          // onBidActionDialogClose={props.onBidActionDialogClose ? props.onBidActionDialogClose : null}
        />
      )}
    </Grid>
  );
};

BidAdminAction.propTypes = {
  bid: PropTypes.object.isRequired,
  // onBidActionDialogClose: PropTypes.func,
};

export default BidAdminAction;
